<template>
  <component :is="tagWrapper" class="def-radio">
    <!--@click.stop prevent double click-->
    <input
      :name="name"
      :value="value"
      :checked="checked"
      :disabled="disabled"
      :required="required"
      type="radio"
      class="def-radio__input"
      @click.stop
    />

    <span class="def-radio__checkbox"></span>
    <span class="def-radio__text">
      <slot />
    </span>
  </component>
</template>

<script setup lang="ts">
const props = defineProps({
  name: {
    type: String,
    // default: 'label',
  },
  value: {
    type: String,
    // default: 'label',
  },
  checked: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    // default: 'label',
  },
  tagWrapper: {
    type: String,
    default: 'label',
  },
  required: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.def-radio {
  display: inline-flex;
  cursor: pointer;
  &__input {
    display: none;
    &:checked + .def-radio__checkbox {
      &:before {
        background-color: #386a8f;
      }
    }
    &:disabled + .def-radio__checkbox,
    &:disabled + .def-radio__text {
      opacity: 0.3;
      pointer-events: none;
    }
    &:invalid + .def-radio__checkbox {
      border-color: var(--color-red);
    }
  }
  &__checkbox {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid var(--border-grey);
    transition: 0.2s linear border-color;
    flex-shrink: 0;
    &:before {
      content: '';
      width: 14px;
      height: 14px;
      background-color: transparent;
      border-radius: 50%;
      transition: 0.2s linear background-color;
    }
  }
  &__text {
    margin-left: 12px;
    font-weight: 500;
    line-height: 125%;
  }
}
</style>
